import React,{useEffect,useState} from 'react';
import { useAuth } from '../auth/AuthContext';
import { configureSoundAccount,soundState,subscribeSound,enableSound,disableSound } from './chatSound';
export default function ChatSoundControl(){
 const {user}=useAuth();
 const [state,setState]=useState(soundState);
 useEffect(()=>{configureSoundAccount(user?.id);setState(soundState());return subscribeSound(()=>setState(soundState()));},[user?.id]);
 const active=state.enabled&&state.ready;
 const label=state.busy?'Loading sound…':state.error?'Retry sound':active?'Sound on':state.enabled?'Enable sound':'Sound off';
 return <button type="button" disabled={state.busy} aria-pressed={active}
  title={state.error?'Sound could not start. Tap again and check your device volume.':active?'Mute message sound':'Enable message sound'}
  onClick={()=>active?disableSound():void enableSound()}>{label}</button>;
}
